import api from './api';
import { OpenTradePayload } from '../types';

export const tradeService = {
  getPrices: () => api.get('/prices'),
  listTrades: (params?: object) => api.get('/trades', { params }),
  getTrade: (id: number) => api.get(`/trades/${id}`),
  openTrade: (data: OpenTradePayload) => api.post('/trades/open', data),
  closeTrade: (id: number) => api.post(`/trades/${id}/close`),

  // Wallet
  getWallets: () => api.get('/wallet'),
  getDepositAddress: (cryptocurrency: string, network?: string) =>
    api.get('/wallet/deposit-address', { params: { cryptocurrency, network } }),
  getAllDepositAddresses: () => api.get('/wallet/deposit-addresses'),
  submitDeposit: (data: object) => api.post('/wallet/deposit', data),
  submitWithdrawal: (data: object) => api.post('/wallet/withdraw', data),
  getTransactions: (params?: object) => api.get('/wallet/transactions', { params }),

  // KYC
  getKycStatus: () => api.get('/kyc'),
  submitKyc: (formData: FormData) => api.post('/kyc/submit', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
};
